import parse from "html-react-parser";

type DisclaimerProps = {
  tr_disclaimer: string;
};

export const Disclaimer = ({ tr_disclaimer }: DisclaimerProps) => (
  <div className="disclaimer content-medium">{parse(tr_disclaimer)}</div>
);
